// Jobber crew numbers and equipment specialties are labels, not names.
const nameParts = name => (String(name || '').match(/\p{L}+(?:['’-]\p{L}+)*/gu) || [])
  .filter(part => !/^(FC|HP|FC-HP|HP-FC)$/i.test(part));

export const jobberDisplayName = name => nameParts(name).join(' ') || '—';
export const jobberInitials = name => nameParts(name)
  .slice(0, 2).map(part => part[0]).join('').toUpperCase();
